"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var yup = _interopRequireWildcard(require("yup"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _actions = require("../../../../bus/ui/actions");
var _actions2 = require("../../store/actions");
var _selectors = require("../../store/selectors");
var _constants = require("../../store/constants");
var _modalStyles = _interopRequireDefault(require("../modalStyles.scss"));
var _check = _interopRequireDefault(require("./check.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var UN_TOUCHED_IS_VALID_VALUE = null;
var NAME_VALIDATION_SCHEMA = yup.string().required('');
var CreateCollectionModal = function CreateCollectionModal(_ref) {
  var countryID = _ref.countryID,
    _onClose = _ref.onClose,
    onSuccess = _ref.onSuccess;
  var _useTranslation = (0, _reactI18next.useTranslation)(['CREATE_COLLECTION_MODAL', 'VALIDATION_ERRORS']),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var ui = (0, _reactRedux.useSelector)(_selectors.getCreateCollectionUI);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    name = _useState2[0],
    setName = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAgentCollection = _useState4[0],
    setIsAgentCollection = _useState4[1];
  var _useState5 = (0, _react.useState)(UN_TOUCHED_IS_VALID_VALUE),
    _useState6 = _slicedToArray(_useState5, 2),
    isValidName = _useState6[0],
    setIsValidName = _useState6[1];
  var handleCreatingCollection = function handleCreatingCollection() {
    return dispatch((0, _actions2.createCollection)(name, isAgentCollection, countryID, function (collection) {
      return onSuccess(collection), _onClose();
    }));
  };
  var validateName = function validateName(value) {
    return R.call(function (isValid) {
      return setIsValidName(isValid), isValid;
    }, NAME_VALIDATION_SCHEMA.isValidSync(value));
  };
  (0, _react.useEffect)(function () {
    return function () {
      return dispatch((0, _actions.unRegister)(_constants.CREATE_COLLECTION_UI_KEY));
    };
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeIcon: true,
    className: _modalStyles.default.collectionsModal,
    onClose: function onClose() {
      return _onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    className: _modalStyles.default.header
  }, t('TITLE')), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, {
    className: _modalStyles.default.content
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: function onSubmit(e) {
      return e.preventDefault(), !ui.loading && validateName(name) && handleCreatingCollection();
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _modalStyles.default.inputWrapper
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: _modalStyles.default.input,
    placeholder: t('NAME_CONTROL_PLACEHOLDER'),
    type: "text",
    value: name,
    onChange: function onChange(e) {
      return setName(e.target.value);
    }
  }), isValidName !== UN_TOUCHED_IS_VALID_VALUE && !isValidName && /*#__PURE__*/_react.default.createElement("div", {
    className: _modalStyles.default.error
  }, t('REQUIRED_FIELD'))), /*#__PURE__*/_react.default.createElement("label", {
    className: _modalStyles.default.checkbox
  }, /*#__PURE__*/_react.default.createElement("input", {
    checked: isAgentCollection,
    type: "checkbox",
    onChange: function onChange(e) {
      return setIsAgentCollection(e.target.checked), validateName(e.target.checked);
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: R.concat(_check.default, t('ALLOW_TO_ALL_TEAMMATES_CONTROL'))
    }
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _modalStyles.default.createButton,
    disabled: ui.loading,
    theme: _Button.THEMES.PURPLE,
    type: "submit"
  }, t('CREATE_BUTTON'), ui.loading && '...'), ui.error && /*#__PURE__*/_react.default.createElement("div", {
    className: _modalStyles.default.error
  }, ui.message))));
};
CreateCollectionModal.propTypes = {
  countryID: _propTypes.default.number.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onSuccess: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _react.memo)(CreateCollectionModal);